import { v4 as uuid } from "uuid";

import { EntityTypes } from "../../EntityTypes";
import { IGroupSpaceItem } from "../../group-spaces";
import { IGroupWorkResource } from "../../group-works";
import { IUserResource } from "../../users";
import { IApiMutationFunction, createApiMutationHook } from "../../utils/api";
import { RelationalValue, mapRelationalValueAsIRI } from "../../utils/filters";

export interface IGroupCorrectionCreateMutationParameters {
    groupSpace: RelationalValue<IGroupSpaceItem>;
    comment: string;
    learner: RelationalValue<IUserResource>;
    groupCorrectedSkillLevels: { skillLevel: string; status: string }[];
}

export type IGroupCorrectionCreateMutationResult = IGroupWorkResource;

export const groupCorrectionCreateMutation: IApiMutationFunction<IGroupCorrectionCreateMutationParameters> = ({
    groupSpace,
    comment,
    learner,
    groupCorrectedSkillLevels,
}) => {
    return {
        method: "POST",
        url: "/group_corrections",
        data: {
            uuid: uuid(),
            groupSpace: mapRelationalValueAsIRI(EntityTypes.GROUP_SPACE, groupSpace),
            learner: mapRelationalValueAsIRI(EntityTypes.USER, learner),
            groupCorrectedSkillLevels,
            comment,
        },
    };
};

export const useGroupCorrectionCreateMutation = createApiMutationHook<
    IGroupCorrectionCreateMutationParameters,
    IGroupCorrectionCreateMutationResult
>(groupCorrectionCreateMutation);
